import React, {createContext, useContext} from 'react';
import {FormikProvider, useFormik} from 'formik';
import {useDispatch} from "react-redux";
import {useTransfersByAgentContext} from './TransfersByAgentContext';
import * as actions from "../_redux/transfersByAgentActions";

const UpdateAdminNotesContext = createContext({});

export const useUpdateAdminNotesContext = () => useContext(UpdateAdminNotesContext);

export const UpdateAdminNotesProvider = ({children}) => {
  const dispatch = useDispatch();
  const {adminNotes, agentId, getTransfersByAgent} = useTransfersByAgentContext();
  const formik = useFormik({
    initialValues: {
      adminNotes: adminNotes || '',
    },
    onSubmit: () => {
    },
    enableReinitialize: true
  });
  const updateAdminNotes = () => {
    dispatch(actions.updateAdminNotes(agentId, formik.values.adminNotes));
    getTransfersByAgent();
  };

  return (
    <UpdateAdminNotesContext.Provider value={{formik, updateAdminNotes}}>
      <FormikProvider value={formik}>
        {children}
      </FormikProvider>
    </UpdateAdminNotesContext.Provider>
  );
};